import { render, staticRenderFns } from "./UserPostEditor.vue?vue&type=template&id=a75c8212"
import script from "./UserPostEditor.vue?vue&type=script&lang=js"
export * from "./UserPostEditor.vue?vue&type=script&lang=js"
import style0 from "./UserPostEditor.vue?vue&type=style&index=0&id=a75c8212&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports